import { StoreExt } from '@utils/reactExt'
import { USER_PENALTY_TYPE } from '@v2/constants/common'

export class PenaltyStore extends StoreExt {

  checkUserPenalty = async (penaltyType: USER_PENALTY_TYPE): Promise<string> => {
    try {
      const result = await this.api.penalty.checkUserPenalty({ penaltyType })
      return result.penaltyMessage
    } catch (err) {
      console.error(err)
    }
  }
}

export default new PenaltyStore()
